import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'jsx/layout/MinimalLayout';
import NavMotion from 'jsx/layout/NavMotion';
import Loadable from 'jsx/components/utilities/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('jsx/pages/Login')));
const AdminLogin = Loadable(lazy(() => import('jsx/views/admin/Auth/Login')));
const Otp = Loadable(lazy(() => import('jsx/views/admin/Auth/Otp')));
const AuthRegister = Loadable(lazy(() => import('jsx/pages/SignUp')));
const AuthForgotPassword = Loadable(lazy(() => import('jsx/pages/authentication/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('jsx/pages/authentication/authentication/ResetPassword')));
const AuthCheckMail = Loadable(lazy(() => import('jsx/pages/authentication/authentication/CheckMail')));
const AuthOtp = Loadable(lazy(() => import('jsx/pages/authentication/authentication/Otp')));
const LoginOtp = Loadable(lazy(() => import('jsx/pages/authentication/authentication/LoginOtp')));
const PagesContactUS = Loadable(lazy(() => import('jsx/pages/contact-us')));
const TermsAndConditions = Loadable(lazy(() => import('jsx/pages/other/TermsAndConditions')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/admin/login',
            element: <AdminLogin />
        },
        {
            path: '/admin/verifyOtp',
            element: <Otp />
        },
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/check-mail',
            element: <AuthCheckMail />
        },
        {
            path: '/reset',
            element: <AuthResetPassword />
        },
        {
            path: '/verify',
            element: <AuthOtp />
        },
        {
            path: '/verify-otp',
            element: <LoginOtp />
        },
        {
            path: '/terms-and-conditions',
            element: <TermsAndConditions />
        }
    ]
};

export default LoginRoutes;
